import React, { useState, useEffect } from "react";
import Dashboard from "./Charts/Dashboard";
import { fetchProgramSummaryStats } from "../../../../../utils/axios";

function ProgramSummary() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await fetchProgramSummaryStats();
      setData(response);
    } catch (err) {
      setError("Failed to fetch data. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2 text-muted">Loading data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-4">
        <div className="text-danger display-6 mb-3">⚠️</div>
        <h5>Error</h5>
        <p className="text-muted">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="btn btn-primary mt-2"
        >
          Retry
        </button>
      </div>
    );
  }

  return data ? (
    <Dashboard data={data} handleRefresh={loadData} />
  ) : (
    <div className="text-center text-muted mt-2">No data available</div>
  );
}

export default ProgramSummary;
